import ChartNivDalingOsmolariteit from "../../../../src/client/niv_acuteboekje/json/daling-osmolariteit.json";
import ChartNivSimple from "../../../../src/client/niv_acuteboekje/interactions/simple/ChartNivSimple.js";
import ButtonSchematic from "../../../../src/client/niv_acuteboekje/ui/ButtonSchematic.js";
import * as React from 'react';
export default {
  ChartNivDalingOsmolariteit,
  ChartNivSimple,
  ButtonSchematic,
  React
};